<div class="input-field">
    <label for="{{label}}">{{label}}</label>
    <input type="{{type}}" id="{{label}}" name="{{label}}" value="{{value}}" [required]="isRequired">
</div>
